<div [ngClass]="{ 'cre-sport-team-frame': circleFrame }">
  <div
    class="cre-sport-team-logo"
    [ngStyle]="{ 'background-image': 'url(' + primaryLogoUrl + ')' }"
  ></div>
</div>
